import classnames from 'classnames';
import { useCallback } from 'react';
import { $a } from 'shared-base';
import { bridge } from '../../globals';
import { Json } from '../../types';
import Materials from '../Materials/Materials';
import { Content, Wrapper } from './NavBarMaterial.style';

export type NavBarMaterialProps = {
  data: {
    editMode: EditMode;
    focusMode: FocusMode;
    isLoading: boolean;
    slotConfig: ISlotConfig;
    slotId: number;
    parametersWithValues: Json;
    materialPack: IMaterialPack;
    materialsGallery: IMaterial[];
  };
  callbacks: {
    onNavigate: (path: string) => void;
    onAction: OnAction;
  };
};

export function NavBarMaterial(props: NavBarMaterialProps) {
  const { data, callbacks } = props;
  const { editMode, slotConfig, materialPack, materialsGallery, slotId } = data;

  function onMaterialSet(change: Json) {
    callbacks.onAction($a('MATERIALS', 'patch', slotId, change));
  }

  const onChangeMaterial = useCallback(
    (change: Json) => {
      bridge.patchMaterial('main', undefined, change);
    },
    [slotId]
  );

  function onSlotChange(value: SlotId) {
    callbacks.onAction($a('MATERIALS', 'slotChange', '', { slotId: value }));
    bridge.setSlotId(value);
  }

  function onLibraryClick(material: IMaterial) {
    callbacks.onAction($a('MATERIALS', 'fromLibrary', '', { material }));
  }

  const className = classnames('bottom', editMode, {});

  return (
    <Wrapper className='NavBarMaterial-wrapper' data-testid='NavBarMaterial-wrapper'>
      <Content className={className}>
        <Materials
          onChange={onChangeMaterial}
          onSet={onMaterialSet}
          onSlotChange={onSlotChange}
          onLibraryClick={onLibraryClick}
          slotConfig={slotConfig}
          slotId={slotId as any}
          materialPack={materialPack}
          materials={materialsGallery}
        ></Materials>
      </Content>
    </Wrapper>
  );
}

export default NavBarMaterial;
